import { PropsWithChildren } from 'react';

import { ClientProvider } from '@hcecbp/provider';

import React from 'react';
import useAuthData from '../../../customHooks/useAuthData';
import { createAxiosInstance } from './createAxiosInstance';
import { getClientConfigs } from './ClientConfig';

export const ClientProviderWrapper = ({ children }: PropsWithChildren<{}>) => {
  const { token } = useAuthData();

  return (
    <ClientProvider createAxiosInstance={createAxiosInstance} clientConfigs={getClientConfigs()} getAuthToken={async () => (!token.startsWith('Bearer ') ? `Bearer ${token}` : token)}>
      {children}
    </ClientProvider>
  );
};
